import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {Offer} from '../../model/offer/offer';
import {NumberParseService} from '../../services/parser/number-parse.service';
import {ApplicationType} from '../../enum/application-type';
import {MatExpansionPanel} from '@angular/material/expansion';
import {OfferType} from '../../enum/offer-type';
import {Route} from '../../enum/route';
import {Router} from '@angular/router';
import {UserService} from '../../services/user/user.service';
import {Store} from '@ngrx/store';
import {ProposalAppState} from '../../store/proposal/reducers/proposal.reducer';
import {selectDetailPageProposal} from '../../store/proposal/selectors/proposal.selectors';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {selectUserAndCompany, selectUserId} from '../../store/user/selectors/user.selectors';
import {map, take} from 'rxjs';
import {PrivateNote} from '../../model/offer/private-note';
import {MatTable} from '@angular/material/table';


@Component({
    selector: 'app-offer-tile',
    templateUrl: './offer-tile.component.html',
    styleUrls: ['./offer-tile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OfferTileComponent implements AfterViewInit {
  @Input() offers: Offer[] = [];
  displayedColumns = ['status', 'creator', 'premium', 'share', 'role'];

  @Input() insuredAmount;
  @Input() selectedOffer: Offer | null;
  @Output() selectedOfferChange = new EventEmitter<Offer>();
  @ViewChild(MatTable) table: MatTable<any>;

  OfferType = OfferType;

  proposalUserId$ = this.proposalStore.select(selectDetailPageProposal).pipe(map(proposal => proposal.creator.id));
  activeUserId$ = this.userStore.select(selectUserId);
  user$ = this.userStore.select(selectUserAndCompany).pipe(take(1), map(userCompany => userCompany.user));
  company$ = this.userStore.select(selectUserAndCompany).pipe(take(1), map(userCompany => userCompany.company));
  NumberParseService = NumberParseService;
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;
  Route = Route;

  @Output() selectedPrivateNote = new EventEmitter<PrivateNote>();

  constructor(
    private readonly router: Router,
    public userService: UserService,
    private readonly proposalStore: Store<ProposalAppState>,
    private readonly userStore: Store<UserAppState>
  ) {
  }

  ngAfterViewInit(): void {
    this.table?.renderRows();
  }

  getRole(offer: Offer) {
    return offer.isLeading ? ApplicationType.LEAD_INSURER : ApplicationType.FOLLOWING_INSURER;
  }

  navigateToUserProfile(userId) {
    this.router.navigate([Route.USER_PAGE, userId]).then();

  }
}
